var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHome01 = function SvgHome01(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 57,
    viewBox: "0 0 50 57",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.74909 5.89746H39.8006C40.7347 5.89746 41.5131 6.62782 41.5131 7.50424V54.3931C41.5131 55.2695 40.7347 55.9999 39.8006 55.9999H2.74909C1.81502 55.9999 1.03662 55.2695 1.03662 54.3931V7.50424C1.03662 6.62782 1.81502 5.89746 2.74909 5.89746Z",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1558 23.1338V31.752",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48584 27.3691H15.6709",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1962 24.4492L27.6577 30.4381",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88647 43.4375L14.425 49.5725",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88647 49.5725L14.425 43.4375",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.19238 36.7188H41.2018",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2747 17.875V55.4153",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7241 44.168H35.9092",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7241 48.8418H35.9092",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8786 23.4263C26.4116 23.8645 26.4116 24.4488 26.8786 24.887C27.3456 25.3252 27.9683 25.3252 28.4354 24.887C28.9024 24.4488 28.9024 23.8645 28.4354 23.4263C28.124 22.9881 27.3456 22.9881 26.8786 23.4263Z",
    stroke: "#2F3447",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7287 29.8541C33.2617 30.2923 33.2617 30.8765 33.7287 31.3148C34.1957 31.753 34.8184 31.753 35.2855 31.3148C35.7525 30.8765 35.7525 30.2923 35.2855 29.8541C34.9741 29.4158 34.1957 29.4158 33.7287 29.8541Z",
    stroke: "#2F3447",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.9256
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1.19238 17.4365H41.2018",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7014 5.88872L47.4251 28.7889C47.4251 30.258 46.1357 31.3814 44.6621 31.3814H28.6368C27.0711 31.3814 25.8738 30.1716 25.8738 28.7889V4.59248C25.8738 3.12341 27.1632 2 28.6368 2H44.6621C45.8594 2 47.7935 2.34566 47.7014 4.59248V5.88872Z",
    fill: "#F5F8FC",
    stroke: "#F5F8FC",
    strokeWidth: 4,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7014 5.88872L47.4251 28.7889C47.4251 30.258 46.1357 31.3814 44.6621 31.3814H28.6368C27.0711 31.3814 25.8738 30.1716 25.8738 28.7889V4.59248C25.8738 3.12341 27.1632 2 28.6368 2H44.6621C45.8594 2 47.7935 2.34566 47.7014 4.59248V5.88872Z",
    stroke: "#2F8BFF",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8994 28.876H38.3992",
    stroke: "#2F8BFF",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.335 26.542H46.8732",
    stroke: "#2F8BFF",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.519 4.76562H47.0573",
    stroke: "#2F8BFF",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome01, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home-01.dcbba922.svg";
export { ForwardRef as ReactComponent };